import NotFoundCard from '@src/components/NotFoundCard';

function NotFoundPage(): JSX.Element {
  return <NotFoundCard />;
}

export default NotFoundPage;
